import { render, staticRenderFns } from "./LeaveDetailsCard.vue?vue&type=template&id=cc44dd88"
import script from "./LeaveDetailsCard.vue?vue&type=script&lang=js"
export * from "./LeaveDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports